/*
  Panier : ligne « ajoute l'écrin » de la barre de livraison offerte (bw-cart-bar).
  L'ajout passe par /cart/add.js, puis le panier Horizon et la barre sont re-rendus
  sans recharger la page (les montants viennent du serveur, réductions comprises).
*/
import { CartLinesUpdateEvent } from '@shopify/events';
import { morphSection, sectionRenderer } from '@theme/section-renderer';

const SOURCE = 'bw-cart-upsell';
const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
const barSectionId = () => document.querySelector('[data-bwc-root]')?.dataset.sectionId;
const cartItemsSectionIds = () =>
  [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);

if (!window.__bwCart) {
  window.__bwCart = true;

  document.addEventListener('change', (e) => {
    const input = e.target.closest?.('[data-bwc-upsell-variant]');
    const img = input?.closest('[data-bwc-upsell]')?.querySelector('[data-bwc-upsell-img]');
    if (img && input.dataset.image) img.src = input.dataset.image;
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest?.('[data-bwc-upsell-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    const box = btn.closest('[data-bwc-upsell]');
    const errorEl = box.querySelector('[data-bwc-upsell-error]');
    const variantId = box.querySelector('[data-bwc-upsell-variant]:checked')?.value || box.dataset.variantId;
    const barId = barSectionId();
    const sections = [...cartItemsSectionIds(), barId].filter(Boolean);

    btn.setAttribute('aria-busy', 'true');
    errorEl.hidden = true;
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || '');
      const cart = await (await fetch(`${root}cart.js`)).json();

      // Le panier Horizon (lignes, total) et le compteur de l'en-tête se mettent à jour via cet événement.
      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'cart',
          lines: [{ merchandiseId: String(variantId), quantity: 1 }],
          promise: deferred.promise,
        })
      );
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { sections: data.sections, items: cart.items, itemCount: cart.item_count, source: SOURCE, didError: false },
      });

      const barHtml = barId && data.sections?.[barId];
      if (barHtml) await morphSection(barId, barHtml);
      else if (barId) await sectionRenderer.renderSection(barId, { cache: false });
    } catch (err) {
      btn.removeAttribute('aria-busy');
      errorEl.textContent = err.message || "Oups, l'ajout n'a pas fonctionné. Réessaie dans un instant.";
      errorEl.hidden = false;
    }
  });

  // Quantité modifiée, ligne supprimée ou code promo : la barre et la ligne écrin suivent.
  // Compteur de l'en-tête bien-être (dans le shadow DOM de <bw-layout>).
  const updateHeaderCount = (count) => {
    if (!Number.isFinite(count)) return;
    document.querySelectorAll('bw-layout').forEach((layout) => {
      layout.shadowRoot?.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = String(count); });
    });
  };
  const refreshBar = (event) => {
    event.promise
      ?.then(({ cart, detail }) => {
        updateHeaderCount(cart?.totalQuantity ?? detail?.itemCount);
        const barId = barSectionId();
        if (!barId || detail?.source === SOURCE) return;
        const html = detail?.sections?.[barId];
        if (html) return morphSection(barId, html);
        return sectionRenderer.renderSection(barId, { cache: false });
      })
      .catch(() => {});
  };
  document.addEventListener(CartLinesUpdateEvent.eventName, refreshBar);
  document.addEventListener('shopify:cart:discount-update', refreshBar);
}
